import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
// import { Link } from 'react-router-dom';

import Waiting from './Waiting';

import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';

import useStyles from '../styles/Styles'

import _ from 'lodash';
import { isTrue, maybeWithPrefix } from '../utils';
import { describeTutor, describeVenue, outputField, getCourseSchedule } from '../utils/courseUtilities';

import { fetchCourse, loadCoursesInfo, loadSettings } from '../actions';

const CourseDetail = ({courseCode, loggedIn, isSm}) => {
	
	const dispatch = useDispatch();
	const course = useSelector(state => state.courses.singles[courseCode]);
	const fetchingCourse = useSelector(state => _.includes(state.courses.fetching_singles, courseCode));
	const courseError = useSelector(state => state.courses.singles_errors[courseCode]);
	
	const coursesSettings = useSelector(state => state.settings.courses.data);
	const courseCategories = useSelector(state => state.settings.course_categories.data);
	const courseFrequencies = useSelector(state => state.settings.course_frequencies.data);
	const courseTypes = useSelector(state => state.settings.course_types.data);
	const courseTutors = useSelector(state => state.settings.tutors.data);
	const courseVenues = useSelector(state => state.settings.venues.data);
	const courseLabels = useSelector(state => state.settings.labels_courses.data);

	const classes = useStyles();

	// courseCode isn't going to change - not a dependency
	useEffect(() => { 
		dispatch(fetchCourse(courseCode)); 
		dispatch(loadSettings('courses'));
		dispatch(loadCoursesInfo('general'));
		dispatch(loadCoursesInfo('tutors')); // eslint-disable-next-line
	}, [dispatch])
	
	const [fieldNames, setFieldNames] = useState({
		code: "Course code", 
		name: "Course name", 
		category_code: "Category", 
		frequency_code: "Frequency", 
		type_code: "Course type", 
		start_date: 'Start date', 
		end_date: 'Finish date', 
		start_time: 'Start time', 
		venue_code: "Venue", 
		day: 'Day of week', 
		is_new: "New courses", 
		tutor: "Tutor",
		tutor2: "",
		fee1: "Full fee", 
		detail: 'Detail', 
		additional_detail: 'Additional information', 
	});
	
	useEffect(() => {
		setFieldNames(f => { return {...f, 
			code: courseLabels.courseCapLabel + " code", 
			name: courseLabels.courseCapLabel + " name", 
			type_code: courseLabels.courseCapLabel + " type",
			// is_new: "New " + courseLabels.courseLabel,
			category_code: courseLabels.category, 
			frequency_code: courseLabels.frequency, 
			venue_code: courseLabels.venue, 
			tutor: courseLabels.tutor, 
			tutor2: courseLabels.tutor2, 
			fee1: courseLabels.fee1
		}});

	}, [courseLabels]);
	
	const [displayFields, setDisplayFields] = useState({
		tutor: false,
		tutor2: false,
		additional_detail: false
	});
	
	useEffect(() => {
		setDisplayFields( f => { return {...f, 
			tutor: loggedIn || !isTrue(coursesSettings.hide_tutor_from_public),
			tutor2: courseLabels.tutor2 !== '' && (loggedIn || !isTrue(coursesSettings.hide_tutor_from_public)),
			additional_detail: coursesSettings.show_additional_detail
		}}); // eslint-disable-next-line
	}, [courseLabels, coursesSettings]);
	
	if(fetchingCourse){
		return  <Waiting message={'Fetching ' + courseLabels.courseLabel + ' detail. Please wait...'} />
	} else if(courseError){
		return <Typography paragraph>{courseError}</Typography>
	} else if(_.isNil(course)){
		return <></>
	} 
	
	const category_description = _.has(courseCategories, course.category_code) ? courseCategories[course.category_code].description : course.category_code;
	const type_desciption = _.has(courseTypes, course.type_code) ? courseTypes[course.type_code].description : course.type_code;
	const frequency = courseFrequencies[course.frequency_code] || null;
	const tutor = courseTutors[course.tutor] || null;
	const tutor2 = courseTutors[course.tutor2] || null;
	const venue = courseVenues[course.venue_code] || null;
	const venueDetail = <>{describeVenue(venue, course.venue_code)} {isTrue(course.distance_course) ? <><br/><strong>This is a distance {courseLabels.courseLabel}</strong></> : null}</>;
	
	return (
		<Grid container className={classes.courseDetails}>
			{outputField(fieldNames.code, course.code, isSm, classes)}
			{outputField(fieldNames.category_code, maybeWithPrefix(course.category_code, category_description), isSm, classes)}
			{outputField(fieldNames.type_code, maybeWithPrefix(course.type_code, type_desciption ), isSm, classes)}
			{outputField(fieldNames.detail, course.detail, isSm, classes)}
			{displayFields.additional_detail ? outputField(fieldNames.additional_detail, course.additional_detail, isSm, classes) : null}
			{displayFields.tutor ? outputField(fieldNames.tutor, describeTutor(tutor, course.tutor), isSm, classes) : null}
			{displayFields.tutor2 ? outputField(fieldNames.tutor2, describeTutor(tutor2, course.tutor2), isSm, classes) : null}
			{outputField(fieldNames.venue_code, venueDetail, isSm, classes)}
			{outputField('Timetable', getCourseSchedule(course, frequency), isSm, classes)}
			{outputField(fieldNames.fee1, '$' + course.fee1, isSm, classes)}
		</Grid>
)}

export default CourseDetail;